import { Injectable } from '@angular/core';
import { Observable, delay, of } from 'rxjs';
import { DtoStudentAITimeline } from '../models/dto-student-ai-timeline';
import { createStudentAITimelineMock } from '../mocks/student-ai-timeline.mock';

/**
 * Mock service for the Student AI Timeline. This is the single service call used
 * by the component. getAITimeline() can be moved into the portal's existing
 * StudentService when the live API is implemented; the signature stays the same.
 */
@Injectable({
  providedIn: 'root',
})
export class StudentService {
  /** Simulated latency so the loading state can be reviewed. */
  private readonly mockLatencyMs = 500;

  getAITimeline(studentId: string): Observable<DtoStudentAITimeline> {
    return of(createStudentAITimelineMock(studentId)).pipe(delay(this.mockLatencyMs));
  }
}
